import type { ArchiveData } from '../types';

export const blog: ArchiveData = {
  page: {
    title: 'My Blog',
    excerpt: 'My Blog Excerpt',
    content: 'My Blog Content',
  },
};